/**
 * Read-aloud playback-rate steps — the single source of truth for the reader's
 * cycling speed pill (DocTtsPlaybackBar). Mirrors the chat playback pill's
 * cycleSpeed (useTTS.ts): tap steps through the list and wraps around.
 */
export const PLAYBACK_RATES = [1, 1.5, 2] as const;
export type PlaybackRate = (typeof PLAYBACK_RATES)[number];

/** Next rate in the cycle, wrapping 2 → 1. Falls back to the first rate for an
 *  unknown current value (defensive — keeps the pill usable if state drifts). */
export function nextPlaybackRate(current: PlaybackRate): PlaybackRate {
  const idx = PLAYBACK_RATES.indexOf(current);
  if (idx === -1) return PLAYBACK_RATES[0];
  return PLAYBACK_RATES[(idx + 1) % PLAYBACK_RATES.length];
}
